// Export the content with a custom ID that will help us identify the image
export const win = `
# Enter Giveaway
<img id="image-full" src="https://operation-give-thanks.s3.us-east-1.amazonaws.com/website/january.png" data-special-giveaway-image="true" />
</br></br>
<div id="logged-in">
<a style="text-align:center;" href="/account/giveaway" id="button">Enter Giveaway</a>
</div>
<div style="text-align:center;" id="logged-out">
<a href="/account/login" id="button">Sign In</a>
<a href="/account/register" id="button">Register</a>
<a href="/account/giveaway" id="button">Enter as Guest</a>
</div>

<hr />
</div>

<script>
(function() {
  // Function to update all giveaway images
  function updateGiveawayImages(url) {
    var images = document.querySelectorAll('img[data-giveaway-image="true"]');
    for (var i = 0; i < images.length; i++) {
      images[i].src = url;
    }
  }

  // First check localStorage for cached URL
  var cachedUrl = localStorage.getItem('giveawayImageUrl');
  if (cachedUrl) {
    updateGiveawayImages(cachedUrl);
  }

  // Then fetch the latest URL
  var xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://kwik.burcs.workers.dev/query', true);
  xhr.setRequestHeader('Authorization', 'Bearer 1b08552890094f86e6038a16d3b4d51a30aec0468565536e55c28e380f7488b2');
  xhr.setRequestHeader('Content-Type', 'application/json');
  
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      try {
        var response = JSON.parse(xhr.responseText);
        if (response && response.result && response.result.length > 0 && response.result[0].r2_key) {
          var imageUrl = response.result[0].r2_key;
          localStorage.setItem('giveawayImageUrl', imageUrl);
          updateGiveawayImages(imageUrl);
        }
      } catch (e) {
        console.error('Error parsing response:', e);
      }
    }
  };
  
  xhr.send(JSON.stringify({
    sql: "SELECT r2_key FROM media WHERE id = 1 AND originalname = 'giveaway.png'"
  }));
})();
</script>
`;